import { useTravelText } from '../../app/TravelLocaleContext';
import { useEffect, useRef } from 'react';
import { canSubmitEdit } from './messageEditModel';

export default function MessageEditComposer({
  value,
  onChange,
  onSave,
  onCancel,
  saving = false,
  error = '',
  disabled = false,
}) {
  const { t } = useTravelText();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
    const el = inputRef.current;
    if (el) {
      const end = el.value.length;
      el.setSelectionRange(end, end);
    }
  }, []);

  function onKeyDown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      if (!saving) onCancel();
      return;
    }
    if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing && event.keyCode !== 229) {
      event.preventDefault();
      if (canSubmitEdit(value) && !saving && !disabled) onSave();
    }
  }

  return (
    <div className="travel-msg-edit">
      <label htmlFor="travel-msg-edit-text">{t('travel.chat.editMessage')}</label>
      <textarea
        id="travel-msg-edit-text"
        ref={inputRef}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={onKeyDown}
        rows={3}
        disabled={saving || disabled}
        aria-busy={saving}
      />
      <div className="travel-msg-edit__actions">
        <button type="button" onClick={onCancel} disabled={saving}>{t('travel.chat.cancel')}</button>
        <button
          type="button"
          onClick={onSave}
          disabled={saving || disabled || !canSubmitEdit(value)}
          aria-busy={saving}
        >
          {t(saving ? 'travel.chat.saving' : 'travel.chat.save')}
        </button>
      </div>
      {error ? <p className="travel-thread__send-error" role="alert" aria-live="assertive">{error}</p> : null}
    </div>
  );
}
